// eslint-disable-next-line import/no-cycle
import conditionalDisplayFieldConfig from '@/components/template-builder/config/fields/conditional-display-config';
// eslint-disable-next-line import/no-cycle
import getConditionalSegments from '@/components/template-builder/getters/conditional-display';
// eslint-disable-next-line import/no-cycle
import setConditionalSegments from '@/components/template-builder/setters/conditional-display';

/**
 * Get conditional display field configuration for a widget or section
 * @param selector - CSS selector for the element (use #{ID} for widget ID)
 * @returns Field configuration object
 */
const getConditionalDisplayField = (selector: string) => ({
  ...conditionalDisplayFieldConfig,
  label: 'templateBuilder.fields.conditionalDisplay',
  selector,
  properties: [{ name: 's-segments', getter: getConditionalSegments, setters: [setConditionalSegments] }],
});

export default getConditionalDisplayField;
